export default __webpack_public_path__ + "static/media/tennis-racket.00b6a25f.svg";